// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"21":"f7bcd9cc","22":"2b4e417b"}[chunkId] + ".js";
};